module.exports = __webpack_public_path__ + "img/product.9e8e8feb.svg";